import styled from "styled-components";
import { colors, fonts } from "../system";

export const DescriptionText = styled.p<{ center?: boolean }>`
  ${props => props.center && "text-align: center;"}
  padding-left: 2px;
  margin: 10px 0 22px;
  color: ${colors.notBlack};
  font-size: 16px;
  line-height: 22px;
  font-weight: 300;
  font-family: ${fonts.primary};
`;
